import { showError } from '@components/app-error';
import { showToast } from '@components/toaster';
import { showConfirmEmailDialog } from '.';

interface SendPreviewEmailOpts {
  name: string;
  user?: { verifiedEmailAt?: Date | null } | null;
  send: () => Promise<unknown>;
}

export async function sendPreviewEmail(opts: SendPreviewEmailOpts): Promise<void> {
  if (opts.user?.verifiedEmailAt === undefined) {
    showConfirmEmailDialog();
    return;
  }
  try {
    await opts.send();
    showToast({
      type: 'ok',
      title: `${opts.name} sent`,
      message: `${opts.name} message sent successfully.`,
    });
  } catch (err) {
    showError(err);
  }
}
